module.exports = __webpack_public_path__ + "img/configgrp.546ef7d0.svg";